(function () {
  const ASSEMBLY_VARIANT_ID = '48809984196836';
  const STORAGE_KEY = 'assembly_selected';

  function initAssembly() {
    const checkbox = document.getElementById('assembly-toggle');
    const checkbox2 = document.getElementById('assembly-toggle-2');
    const collapsed = document.getElementById('assembly-collapsed');
    const expanded = document.getElementById('assembly-expanded');
    if (!checkbox) return;

function setChecked(checked) {
  checkbox.checked = checked;
  if (checkbox2) checkbox2.checked = checked;
  const buyNowWrapper = document.querySelector('.shopify-payment-button');
  const addToCartBtn = document.querySelector('[name="add"]');
  if (checked) {
    collapsed.style.display = 'none';
    expanded.style.display = 'block';
    sessionStorage.setItem(STORAGE_KEY, 'true');
    if (buyNowWrapper) buyNowWrapper.style.display = 'none';
    if (addToCartBtn) {
      addToCartBtn.style.backgroundColor = '#5D3FD3';
      addToCartBtn.style.color = '#ffffff';
      addToCartBtn.style.borderColor = '#5D3FD3';
    }
  } else {
    collapsed.style.display = 'flex';
    expanded.style.display = 'none';
    sessionStorage.removeItem(STORAGE_KEY);
    if (buyNowWrapper) buyNowWrapper.style.display = '';
    if (addToCartBtn) {
      addToCartBtn.style.backgroundColor = '';
      addToCartBtn.style.color = '';
      addToCartBtn.style.borderColor = '';
    }
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: ASSEMBLY_VARIANT_ID, quantity: 0 })
    });
  }
}

    if (sessionStorage.getItem(STORAGE_KEY) === 'true') {
      setChecked(true);
    }

    checkbox.addEventListener('change', function () {
      setChecked(checkbox.checked);
    });

    const productForm = document.querySelector('product-form');
    if (!productForm) return;
    const form = productForm.querySelector('form');
    if (!form) return;

    form.addEventListener('submit', function () {
      if (sessionStorage.getItem(STORAGE_KEY) === 'true') {
        let hidden = form.querySelector('#assembly-hidden-input');
        if (!hidden) {
          hidden = document.createElement('input');
          hidden.type = 'hidden';
          hidden.name = 'items[][id]';
          hidden.id = 'assembly-hidden-input';
          form.appendChild(hidden);
        }
        hidden.value = ASSEMBLY_VARIANT_ID;
      } else {
        const existing = form.querySelector('#assembly-hidden-input');
        if (existing) existing.remove();
      }
    }, true);
  }

  document.addEventListener('DOMContentLoaded', initAssembly);
  document.addEventListener('shopify:section:load', initAssembly);
  document.addEventListener('variant:change', () => setTimeout(initAssembly, 150));
  window.addEventListener('beforeunload', () => sessionStorage.removeItem(STORAGE_KEY));
})();